export default {
  users: {
    title: "Users",
    usersExplain: "Placeholder for users explanation.",
    searchForUser: "Search user",
    startBySearchingAUser: "Start by searching for users",
    searchForUserDescription: "This realm has a federated provider. Viewing all users may cause the system to slow down. Please search for a user above.",
    createUser: "Create user",
    createNewUser: "Create new user",
    noUsersFound: "No users found",
    noUsersFoundError: "No users found due to {{error}}",
    noGroups: "No groups",
    noGroupsText: "You haven't added this user to any groups. Join a group to get started.",
    joinGroup: "Join Group",
    joinGroups: "Join Groups",
    join: "Join",
    joinGroupsFor: "Join groups for user {{username}}",
    selectGroups: "Select groups to join",
    searchForGroups: "Search for groups",
    leave: "Leave",
    leaveGroup_one: "Leave group {{name}}?",
    leaveGroup_other: "Leave groups?",
    leaveGroupConfirmDialog_one: "Are you sure you want to remove {{username}} from the group {{groupname}}?",
    leaveGroupConfirmDialog_other: "Are you sure you want to remove {{username}} from the {{count}} selected groups?",
    directMembership: "Direct membership",
    groupMembership: "Group membership",
    addedGroupMembership: "Added group membership",
    addedGroupMembershipError: "Error adding group membership",
    removedGroupMembership: "Removed group membership",
    removedGroupMembershipError: "Error removing group membership",
    path: "Path",
    emptyInstructions: "Change your search criteria or add a user",
    createdAt: "Created at",
    username: "Username",
    email: "Email",
    emailVerified: "Email verified",
    lastName: "Last name",
    firstName: "First name",
    status: "Status",
    disabled: "Disabled",
    temporaryLocked: "Temporarily locked",
    unlockSuccess: "User successfully unlocked",
    unlockError: "Could not unlock user due to {{error}}",
    emailInvalid: "You must enter a valid email.",
    temporaryDisabled: "Temporarily disabled",
    notVerified: "Not verified",
    requiredUserActions: "Required user actions",
    addUser: "Add user",
    impersonate: "Impersonate",
    impersonateConfirm: "Impersonate user?",
    impersonateConfirmDialog: "Are you sure you want to log in as this user? If this user is in the same realm with you, your current login session will be logged out before you log in as this user.",
    impersonateError: "Could not impersonate the user: {{error}}",
    deleteUser: "Delete user",
    deleteConfirm: "Delete user?",
    deleteConfirmCurrentUser: "Are you sure you want to permanently delete this user",
    deleteConfirmDialog_one: "Are you sure you want to permanently delete {{count}} selected user",
    deleteConfirmDialog_other: "Are you sure you want to permanently delete {{count}} selected users",
    userID: "User ID",
    userCreated: "The user has been created",
    userSaved: "The user has been saved",
    userDetails: "User details",
    userCreateError: "Could not create user: {{error}}",
    userDeletedSuccess: "The user has been deleted",
    userDeletedError: "The user could not be deleted {{error}}",
    linkAccount: "Link account",
    unlink: "Unlink",
    unlinkAccount: "Unlink account",
    unlinkAccountTitle: "Unlink account from {{provider}}?",
    unlinkAccountConfirm: "Are you sure you want to permanently unlink this account from {{provider}}?",
    link: "Link",
    linkAccountTitle: "Link account to {{provider}}?",
    idpLinkSuccess: "Identity provider has been linked",
    couldNotLinkIdP: "Could not link identity provider {{error}}",
    configureOTP: "Configure OTP",
    updatePassword: "Update Password",
    updateProfile: "Update Profile",
    verifyEmail: "Verify Email",
    updateUserLocale: "Update User Locale",
    consents: "Consents",
    noConsents: "No consents",
    noConsentsText: "The consents will only be recorded when users try to access a client that is configured to require consent. In that case, users will get a consent page which asks them to grant access to the client.",
    identityProvider: "Identity provider",
    identityProviderLinks: "Identity provider links",
    noProvidersLinked: "No identity providers linked. Choose one from the list below.",
    noAvailableIdentityProviders: "No available identity providers.",
    linkedIdPs: "Linked identity providers",
    linkedIdPsText: "The identity providers which are already linked to this user account",
    availableIdPs: "Available identity providers",
    availableIdPsText: "All the configured identity providers in this realm are listed here. You can link the user account to any of the IdP accounts.",
    whoWillAppearLinkText: "Who will appear in this group list?",
    whoWillAppearPopoverText: "Groups are hierarchical. When you select Direct Membership, you see only the child group that the user joined. Ancestor groups are not included.",
    revoke: "Revoke",
    revokeClientScopesTitle: "Revoke all granted client scopes?",
    revokeClientScopes: "Are you sure you want to revoke all granted client scopes for {{clientId}}?",
    deleteGrantsSuccess: "Grants successfully revoked.",
    deleteGrantsError: "Error deleting grants.",
    roleMapping: "Role mapping",
    unlockAllUsers: "Unlock all users",
    unlockUsersConfirm: "All the users that are temporarily locked will be unlocked.",
    unlock: "Unlock",
    unlockUsersSuccess: "Any temporarily locked users are now unlocked",
    unlockUsersError: "Could not unlock all users {{error}}",
    noCredentials: "No credentials",
    noCredentialsText: "This user does not have any credentials. You can set password for this user.",
    setPassword: "Set password",
    setPasswordFor: "Set password for {{username}}",
    save: "Save",
    cancel: "Cancel",
    savePasswordSuccess: "The password has been set successfully.",
    savePasswordError: "Error saving password: {{error}}",
    confirmPasswordDoesNotMatch: "Password and confirmation does not match.",
    credentialType: "Type",
    credentialUserLabel: "User Label",
    credentialData: "Data",
    credentialsList: "Credentials List",
    setPasswordConfirm: "Set password?",
    setPasswordConfirmText: "Are you sure you want to set the password for the user {{username}}?",
    password: "Password",
    passwordConfirmation: "Password confirmation",
    resetPasswordConfirmation: "New password confirmation",
    savePassword: "Save password",
    deleteCredentialsConfirmTitle: "Delete credentials?",
    deleteCredentialsConfirm: "Are you sure you want to delete these users credentials?",
    deleteCredentialsSuccess: "The credentials has been deleted successfully.",
    deleteCredentialsError: "Error deleting users credentials: {{error}}",
    deleteBtn: "Delete",
    resetPasswordFor: "Reset password for {{username}}",
    resetPasswordConfirm: "Reset password?",
    resetPasswordConfirmText: "Are you sure you want to reset the password for the user {{username}}?",
    resetPassword: "Reset password",
    resetCredentialsSuccess: "The password has been reset successfully.",
    resetCredentialsError: "Error resetting users credentials: {{error}}",
    resetPasswordError: "Error resetting password: {{error}}",
    resetPasswordBtn: "Reset password",
    showPasswordDataName: "Name",
    showPasswordDataValue: "Value",
    showDataBtn: "Show data",
    userCredentialsHelpText: "The top level handlers allow you to shift the priority of the credential for the user, the topmost credential having the highest priority. The handlers within one expandable panel allow you to change the visual order of the credentials, the topmost credential will show at the most left.",
    userCredentialsHelpTextLabel: "User Credentials Help Text",
    type: "Type",
    userLabel: "User label",
    data: "Data",
    passwordDataTitle: "Password data",
    updateCredentialUserLabelSuccess: "The user label has been changed successfully.",
    updateCredentialUserLabelError: "Error changing user label: {{error}}",
    credentialReset: "Credentials Reset",
    credentialResetBtn: "Credential Reset",
    resetActions: "Reset Actions",
    lifespan: "Expires In",
    VERIFY_EMAIL: "Verify Email (VERIFY_EMAIL)",
    UPDATE_PASSWORD: "Update password (UPDATE_PASSWORD)",
    UPDATE_PROFILE: "Update Profile (UPDATE_PROFILE)",
    CONFIGURE_TOTP: "Configure OTP (CONFIGURE_TOTP)",
    terms_and_conditions: "Terms and Conditions (terms_and_conditions)",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
    credentialResetConfirm: "Send Email",
    credentialResetConfirmText: "Are you sure you want to send email to user",
    credentialResetEmailSuccess: "Email sent to user.",
    credentialResetEmailError: "Failed: {{error}}"
  }
};
